import React, { useState, useEffect } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Login from '../pages/Login';
import Indicators from "../pages/RoadConstruct/RoadRepair/components/Indicators";
import Ecology from '../pages/Ecology';
import Economic from "../pages/Economic";
import Safety from "../pages/Safety";
import Social2 from "../pages/Social2";
import { withAuthorized } from '../hoc/Authorized';
import MainLayout from '../layout/MainLayout';import UserProfile from '../pages/Profile';
const URL_COMPONENTS = {
  '/safety': Safety,
  '/social': Social2,
  '/ecology': Ecology,
  '/economic': Economic,
};

// Оборачиваем MainLayout в HOC
const ProtectedLayout = withAuthorized(MainLayout);

const Router = () => {
  const [navigation, setNavigation] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = window.localStorage.getItem('user_params');
    if (userData) {
      const parsedUser = JSON.parse(userData);
      setUser(parsedUser);
      getNav(parsedUser);
    }
    setLoading(false);
  }, []);

  const getNav = (user) => {
    const { tabs, subtabs } = user.roles[0];
    const navigation = tabs
      .map((tab) => ({
        ...tab,
        children: subtabs.filter((subtab) => subtab.tabId === tab.id)
      }))
      .filter((e) => e.children.length);

    setNavigation(navigation);
  };

  if (loading) {
    return null; // Спиннер или любой прелоадер
  }

  // Если пользователя нет, показываем только роут для Login
  if (!user) {
    return (
      <Routes>
        <Route path="/signin" element={<Login />} />
        <Route path="*" element={<Navigate to="/signin" replace />} />
      </Routes>
    );
  }

  // Если пользователь есть — рендерим защищенные маршруты
  const economyTab = navigation.find((tab) => tab.name === 'Общественная безопасность');
  const economyChildren = economyTab?.children || [];

  return (
    <Routes>
      <Route path="/signin" element={<Login />} />с
      <Route
        path="/"
        element={
          <ProtectedLayout
            component={Safety}
            subtabs={economyChildren}
          />
        }
      />

      {navigation.map((tab) => {
        const url = new URL(tab.url, window.location.origin).pathname;
        const Component = URL_COMPONENTS[url];

        return (
          <Route
            key={tab.id}
            path={url}
            element={
              <ProtectedLayout component={Component} subtabs={tab.children} />
            }
          />
        );
      })}
        <Route
            path="/profile"
            element={<ProtectedLayout component={UserProfile} />}
        />
      <Route
        path="/indicators"
        element={<ProtectedLayout component={Indicators} />}
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default Router;
